import styled, {css} from 'styled-components'

const tooltipType = ({type}) => {
  if(type === 'medium') {
    return css`
      padding: 24px 8px;    
    `
  } else if (type === 'big') {
    return css`
      padding: 32px 16px;        
    `
  }
}

const tooltipTitleType = ({type}) => {
  if(type === 'medium') {
    return css`
      margin-bottom: 8px;
      font-size: 14px;
      line-height: 16px;
    `
  } else if (type === 'big') {
    return css`
      margin-bottom: 16px;
      font-size: 16px;
      line-height: 24px;
    `
  }
}

export const StyledTooltip = styled.div`
  border-radius: 8px;  
`

export const TooltipHint = styled.div`  
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  display: block;
  text-align: left;
  ${tooltipType}
  a {
    color: #FFF;
  }
`

export const TooltipHintTitle = styled.div`  
  font-weight: 600;  
  ${tooltipTitleType} 
`

export const TooltipLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;  
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;  
  margin: 0;
`
